// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"Textarea_inputWrapper__eJVrd","label":"Textarea_label__Kbsvj","input":"Textarea_input__fA_wQ","error":"Textarea_error__RPZ5Z"};